import { FaEye } from 'react-icons/fa6'

import { Button } from '../../../../../components/Button'
import { LogActions, logActionsMap } from '../../../../../interfaces/logActions'
import { Log } from '../../../../../services/logsService'

interface TableLogsRowProps {
  log: Log
  onSeeChanges: (changes: object, file?: string | null) => void
}

export function LogsTableRow({ log, onSeeChanges }: TableLogsRowProps) {
  return (
    <tr
      className="border-t border-slate-500 hover:bg-white_transparency hover:bg-opacity-15"
    >
      <td
        scope="row"
        className="font-medium whitespace-nowrap sticky left-0 border-r border-slate-500 pl-2"
      >
        <span>{log.user.name}</span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap text-center sticky left-0 border-r border-slate-500 p-2"
      >
        <span>{log.resource}</span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap text-center sticky left-0 border-r border-slate-500 p-2"
      >
        <span>{logActionsMap[log.action as LogActions]}</span>
      </td>
      <td
        scope="row"
        className="font-medium text-dark whitespace-nowrap sticky p-2 text-center"
      >
        <div className="flex flex-row justify-center">
          <Button
            size="icon"
            title="Inspecionar log"
            onClick={() => onSeeChanges(log.changes, log.file)}
            className="disabled:bg-slate-400 hover:disabled:bg-slate-400 disabled:cursor-not-allowed"
          >
            <FaEye />
          </Button>
        </div>
      </td>
    </tr>
  )
}
